<template>
  <custom-callout
    :border-color="getStatusColor"
    class="mb-3"
    :has-toggle="isRefund"
    :opened="isOpen"
    @click:open="onOpenClose"
  >
    <div class="row mx-auto p-0 py-2">
      <div class="col-2 text-center border-right p-0 pr-3">
        <div
          :class="
            `badge badge-pill font-16 py-2 mt-2 w-70 mx-auto color-black bg-${getStatusColor}`
          "
        >
          {{ data.requestStatusName }}
        </div>
        <div class="mt-2 pt-1">
          <div class="color-black font-weight-bold">
            {{ data.requestNumber }}
          </div>
        </div>
      </div>
      <div class="col-8 p-0">
        <div class="row mx-auto p-0 py-3">
          <div class="col-12 col-md-4 pl-4">
            <div>
              <span class="color-gray-6 d-block font-14">
                Nombre del Estudiante:
              </span>
              <span class="font-16 color-black">
                {{ data.studentNameSie }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div>
              <span class="color-gray-6 d-block font-14">
                Mes:
              </span>
              <span class="font-16 color-black">
                {{ selectedPeriods(data.periods) }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md">
            <div>
              <span class="color-gray-6 d-block font-14">
                Determinación:
              </span>
              <span class="font-16 color-black">
                {{ data.requestTypeName }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md ">
            <div>
              <span class="color-gray-6 d-block font-14">Monto:</span>
              <b v-if="data.amountToRefund" class="font-16 color-green">
                ${{ data.amountToRefund | currency }}
              </b>
              <b v-else class="font-16 color-green">
                $0.00
              </b>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div v-if="data.submittedDate" class="col-12 col-md-4 pl-4">
                <div class="pt-3">
                  <span class="color-gray-6 d-block font-14">
                    Fecha de Sometido:
                  </span>
                  <div class="font-16 color-black">
                    {{ data.submittedDate | date | empty }}
                  </div>
                </div>
              </div>
              <div
                class="col-12 col-md"
                :class="{ 'pl-4': !data.submittedDate }"
              >
                <div class="pt-3">
                  <span class="color-gray-6 d-block font-14">
                    Institución:
                  </span>
                  <span class="font-16 color-black">
                    {{ data.schoolName }}
                  </span>
                </div>
              </div>
              <div
                v-if="data.selectedServices.length > 0"
                class="col-12 col-md"
              >
                <div class="pt-3">
                  <span class="color-gray-6 d-block font-14">
                    Servicios:
                  </span>
                  <span class="font-16 color-black">
                    {{ data.selectedServices.join(',') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2  ">
        <div class="row">
          <div class="col-12  pt-1">
            <action-button
              id="on-detail-btn-identifier"
              i="fas fa-file-import"
              variant="outline-success"
              @click="onDetailHandler"
            >
              Entrar
            </action-button>
          </div>
          <div v-if="canCreateAdditionalPayment" class="col-12  pt-1">
            <action-button
              id="on-detail-btn-identifier"
              i="fas fa-file-import"
              variant="outline-success"
              @click="onAdditionalPaymentClick(data.requestId)"
            >
              Pago Adicional
            </action-button>
          </div>
          <div v-if="canViewAI" class="col-12  pt-1">
            <action-button
              id="on-detail-btn-identifier"
              i="fas fa-robot"
              variant="outline-success"
              @click="onAIValidationHandler"
            >
              Validar
            </action-button>
          </div>
        </div>
      </div>
      <div
        v-if="checkable"
        class="col-12 col-md-1 py-0 pl-3 d-flex align-items-center justify-content-center row-check-section"
      >
        <check-box
          v-model="data.checked"
          :class="[{ checked: data.checked }]"
          @input="onCheckHandler"
        />
      </div>
    </div>

    <template #edition>
      <div class="additional-container">
        <div class="p2 mt-1">
          <div class="bg-gray p-2">
            <div class="bg-white p-3 rounded pl-c-xl">
              <custom-tab
                content-class="mt-3"
                nav-class="nav-vue-underline"
                :no-nav-style="true"
              >
                <custom-tab-item
                  class="mt-2 regular"
                  title="Información Adicional"
                >
                  <icon-view
                    class=" ml-3"
                    icon="fas fa-info-circle"
                    icon-background="#FFF"
                    icon-color="#ff7058"
                    icon-size="16px"
                    title="Información Adicional"
                  />
                  <div class="row pl-5 pr-4 pb-4">
                    <div class="col-12 col-md-2 pt-4">
                      <div class=" ml-2 regular text-gray">
                        Número de Consulta:
                      </div>
                      <div class=" ml-2 regular color-black">
                        {{ data.tapRequestNumber | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-2 pt-4">
                      <div class="font-14 text-gray">
                        Centro:
                      </div>
                      <div class="regular color-black">
                        {{ data.centerName | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-2 pt-4">
                      <div class="font-14 text-gray">
                        Municipio:
                      </div>
                      <div class="regular color-black">
                        {{ data.municipalityName | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-2 pt-4">
                      <div class="font-14 text-gray">
                        Escuela:
                      </div>
                      <div class="regular color-black">
                        {{ data.schoolName | empty }}
                      </div>
                    </div>
                  </div>
                </custom-tab-item>
                <custom-tab-item
                  class="mt-2 regular"
                  title="Información de Contacto"
                  @click="getContactInformation"
                >
                  <icon-view
                    class=" ml-3"
                    icon="fas fa-info-circle"
                    icon-background="#FFF"
                    icon-color="#ff7058"
                    icon-size="16px"
                    title="Información de Contacto"
                  />
                  <div class="row pl-5 pr-4 pb-4">
                    <div class="col-12 col-md-2 pt-4">
                      <div class=" ml-2 regular text-gray">
                        Nombre:
                      </div>
                      <div class=" ml-2 regular color-black">
                        {{ contactInformation.contactName | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-2 pt-4">
                      <div class="font-14 text-gray">
                        Parentesco:
                      </div>
                      <div class="regular color-black">
                        {{ contactInformation.contactRelationName | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-2 pt-4">
                      <div class="font-14 text-gray">
                        Correo electrónico:
                      </div>
                      <div class="regular color-black">
                        {{ contactInformation.contactEmail | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-2 pt-4">
                      <div class="font-14 text-gray">
                        Teléfono:
                      </div>
                      <div class="regular color-black">
                        {{ contactInformation.contactTelephone | phone }}
                      </div>
                    </div>
                  </div>
                </custom-tab-item>
              </custom-tab>
            </div>
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomTab from 'custom-tabs/src/CustomTab';
import CustomTabItem from 'custom-tabs/src/CustomTabItem';
import CheckBox from 'CheckBox';
import disbursementRequestType from '@/utils/constants/disbursementRequestType';
//utils
import { parseStateColorByDisbursementStatus } from '@/utils/shared/constants/disbursementRequestStatuses';
import IconView from 'icon-view';
import moment from 'moment';
import 'moment/locale/es-do';
import disbursementRequestStatus from '@/utils/constants/disbursementRequestStatus';

import { createAdditionalPayment as _createAdditionalPayment } from '@/modules/reinbursement/api';
import { getContactInformation as _getContactInformation } from '@/modules/student/api';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
    CustomTab,
    CustomTabItem,
    IconView,
    CheckBox,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    checkable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpen: false,
      disbursementRequestStatus,
      disbursementRequestType,
      contactInformation: {},
    };
  },
  computed: {
    canCreateAdditionalPayment() {
      return (
        this.userHasPermissions(
          'provider.reinbursement.additionalpayment.create'
        ) &&
        this.data.requestStatusId == disbursementRequestStatus.Pagado &&
        this.data.requestTypeId == disbursementRequestType.Refund &&
        !this.data.isAdditionalPayment
      );
    },
    getStatusColor() {
      return parseStateColorByDisbursementStatus(this.data.requestStatusId);
    },
    isRefund() {
      return disbursementRequestType.Refund == this.data.requestTypeId;
    },
    selectedPeriods() {
      return (periods) => {
        if (!periods?.length) return '-';

        const periodNames = periods.map((p) => {
          const monthName = moment()
            .month(p.monthNumber - 1)
            .format('MMMM');
          const capitalizedMonth =
            monthName[0].toUpperCase() + monthName.slice(1).toLowerCase();

          return `${capitalizedMonth} ${p.year}`;
        });

        return periodNames.join(', ');
      };
    },
    canViewAI() {
      return this.userHasPermissions('provider.disbursement.AIAnalysis');
    },
  },
  methods: {
    async onAdditionalPaymentClick(requestId) {
      let additionalPaymentId = (await _createAdditionalPayment(requestId))
        .data;
      this.$router.push({
        name: 'ReimbursementDetail',
        params: { requestId: additionalPaymentId },
      });
    },
    onOpenClose() {
      this.isOpen = !this.isOpen;
    },
    onDetailHandler() {
      this.$router.push({
        name: 'ReimbursementDetail',
        params: { requestId: this.data.requestId },
      });
    },
    onCheckHandler(value) {
      this.$emit('check', this.data, value);
    },
    async getContactInformation() {
      const { data } = await _getContactInformation(this.data.studentSie);
      this.contactInformation = data;
    },
    onAIValidationHandler() {
      this.$router.push({
        name: 'AIReinbursementValidation',
        params: { requestId: this.data.requestId },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.row-check-section {
  max-width: 4.333333% !important;
  border-left: 1px solid #dee2e6 !important;
}

.row-check-section ::v-deep .input-group.checked .option-input + label span {
  background-color: map-get($colors, 'green') !important;
}
.row-check-section
  ::v-deep
  .input-group
  .option-input:checked
  + label
  span
  .ic-check {
  background-image: url('../../../../assets/img/white-check.svg');
  background-size: 70%;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
